import { createFileRoute, redirect } from "@tanstack/react-router"
export const Route = createFileRoute("/_authenticated/companies/$companyId/readiness")({
    beforeLoad: ({ params }) => {
        throw redirect({ to: "/companies/$companyId", params, hash: "readiness", replace: true })
    },
})
